import {Component, OnDestroy, OnInit} from "@angular/core";
import {UtilsService} from "../../core/utils/utils.service";
import {InternationalizationService} from "../../core/services/i8n/i8n.service";
import {ToastService} from "../../core/services/technique/toast.service";
import {Subscription} from "rxjs";
import {
  PointTeledeclarationEgalimSavedSupplier,
  PointTeledeclarationEgalimService
} from "../../core/services/entities/point-teledeclaration-egalim.service";
import {PointTeledeclarationEgalimDto} from "../../core/dtos/egalim/point-teledeclaration-egalim-dto";
import {confirm} from "devextreme/ui/dialog";
import {ResponseWrapper} from "../../core/suppliers/wrappers/response-wrapper";
import {IsDeletableObject} from "../../core/models/is-deletable-object";
import {MSG_KEY, MSG_SEVERITY} from "../../core/constants";

@Component({
  templateUrl: './point-teledeclaration-egalim.component.html',
  styleUrls: ['./point-teledeclaration-egalim.component.scss']
})
export class PointTeledeclarationEgalimComponent implements OnInit, OnDestroy {

  pointsTeledeclaration: PointTeledeclarationEgalimDto[] = [];

  selectedRows: number[] = [];

  findAllSub: Subscription;
  pointTeledeclarationSavedSub: Subscription;
  deleteSub: Subscription;

  constructor(public utils: UtilsService,
              private i8nSvc: InternationalizationService,
              public pointTeledeclarationEgalimSvc: PointTeledeclarationEgalimService,
              public toastSvc: ToastService) {
  }


  ngOnInit(): void {
    this.initData();
    this.initPointTeledeclarationEgalimSavedSubscription();
  }

  initData(): void {
    this.findAllSub = this.pointTeledeclarationEgalimSvc.findAllPointTeledeclarationEgalim().subscribe(response => {
      this.pointsTeledeclaration = response.allPointTeledeclarationEGAlim;
    });
  }

  initPointTeledeclarationEgalimSavedSubscription = (): void => {
    this.pointTeledeclarationSavedSub = this.pointTeledeclarationEgalimSvc.pointTeledeclarationEgalimSaved$
      .subscribe((response: PointTeledeclarationEgalimSavedSupplier) => {
        if (response.isUpdate) {
          const idx: number = this.pointsTeledeclaration.findIndex(PointTeledeclarationEgalim => PointTeledeclarationEgalim.id === response.pointTeledeclarationEgalim.id);
          this.pointsTeledeclaration[idx] = response.pointTeledeclarationEgalim;
        } else {
          this.pointsTeledeclaration.push(response.pointTeledeclarationEgalim);
        }
      });
  };

  openDialogEdition = (pointTeledeclaration: PointTeledeclarationEgalimDto): void => {
    this.pointTeledeclarationEgalimSvc.announceOpenDialogEditionPointTeledeclarationEgalim(pointTeledeclaration);
  };

  deleteValues = async (): Promise<void> => {
    let idsToDeleteInTable = Object.assign([], this.selectedRows);

    const isDeletionValidated: boolean = await confirm(this.i8nSvc.getLabelFromCode(idsToDeleteInTable.length > 1 ? 'CONFIRM_DELETION_PLURAL' : 'CONFIRM_DELETION_SINGULAR', null), this.i8nSvc.getLabelFromCode("Suppression", null));

    if (!isDeletionValidated)
      return new Promise(null);

    this.deleteSub = this.pointTeledeclarationEgalimSvc.deletePointTeledeclarationEgalim(this.selectedRows).subscribe(response => {
      const res: any = (response as ResponseWrapper<IsDeletableObject>).one;

      if (res) {
        if (res.messagesErrorList && res.messagesErrorList.length > 0) {
          for (const error of res.messagesErrorList) {
            const elementToKeep = this.pointsTeledeclaration.find(pointFacturation => pointFacturation.code === error.args);
            idsToDeleteInTable = idsToDeleteInTable.filter(id => elementToKeep.id !== id);
          }
        } else {
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, this.i8nSvc.getLabelFromCode(idsToDeleteInTable.length > 1 ? `DELETION_COMPLETED_PLURAL` : `DELETION_COMPLETED_SINGULAR`, null));
        }
        this.pointsTeledeclaration = this.pointsTeledeclaration.filter(pointFacturation => !idsToDeleteInTable.find(id => id === pointFacturation.id));
      }
    });
  }

  calculateSiteValue = (pointTeledeclaration: PointTeledeclarationEgalimDto): string => {
    return pointTeledeclaration?.site?.libelle
  };


  canDelete = (): boolean => this.selectedRows.length > 0;

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.pointTeledeclarationSavedSub);
    this.utils.unsubscribe(this.findAllSub);
    this.utils.unsubscribe(this.deleteSub);
  }
}
